import { useContext } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { useModal } from 'components/Modals';
import { Controller, useForm } from 'react-hook-form';
import { AnuncioContext } from 'contexts/AnuncioContext';
import Button from 'components/Button';

const SyncModal = ({ itens = [], callback }) => {
  const defaultValues = {
    ids: itens?.map((i) => i.id),
    preco: false,
    saldo: false,
    imagens: false,
    produto: false,
  };
  const { closeModal } = useModal();
  const { control, handleSubmit } = useForm({ defaultValues });
  const { postLoading, syncAnuncio } = useContext(AnuncioContext);

  const onSubmit = (data) => syncAnuncio({ data, cb: callback });

  return (
    <>
      <DialogTitle>Sincronizar Anúncios</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color="text.secondary">
              Escolha quais informações deseja sincronizar.
            </Typography>
            <Typography color="text.secondary">
              Com o toggle ativado, os dados selecionados serão enviados e os
              demais serão atualizados automaticamente.
            </Typography>
            <Typography color="text.secondary">
              Com o toggle desativado, as informações serão apenas recebidas da
              plataforma.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="preco"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  label="Preço"
                  control={
                    <Switch
                      {...field}
                      checked={field?.value}
                      onChange={(e) => field?.onChange(e?.target?.checked)}
                    />
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="saldo"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  label="Saldo"
                  control={
                    <Switch
                      {...field}
                      checked={field?.value}
                      onChange={(e) => field?.onChange(e?.target?.checked)}
                    />
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="imagens"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  label="Imagens"
                  control={
                    <Switch
                      {...field}
                      checked={field?.value}
                      onChange={(e) => field?.onChange(e?.target?.checked)}
                    />
                  }
                />
              )}
            />
          </Grid>
          <Grid item xs={12}>
            <Controller
              name="produto"
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  label="Produto"
                  control={
                    <Switch
                      {...field}
                      checked={field?.value}
                      onChange={(e) => field?.onChange(e?.target?.checked)}
                    />
                  }
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit(onSubmit)} loading={postLoading}>
          Confirmar
        </Button>
        <Button onClick={closeModal} color="secondary">
          Cancelar
        </Button>
      </DialogActions>
    </>
  );
};

export default SyncModal;
